const timezoneList = [
  {
    label: '(UTC-11:00) Midway Island',
    value: 'Pacific/Midway'
  },
  {
    label: '(UTC-11:00) Samoa',
    value: 'US/Samoa'
  },
  {
    label: '(UTC-10:00) Hawaii',
    value: 'US/Hawaii'
  },
  {
    label: '(UTC-09:00) Alaska',
    value: 'US/Alaska'
  },
  {
    label: '(UTC-08:00) Pacific Time (US & Canada)',
    value: 'US/Pacific'
  },
  {
    label: '(UTC-08:00) Tijuana',
    value: 'America/Tijuana'
  },
  {
    label: '(UTC-07:00) Arizona',
    value: 'US/Arizona'
  },
  {
    label: '(UTC-07:00) Mountain Time (US & Canada)',
    value: 'US/Mountain'
  },
  {
    label: '(UTC-07:00) Chihuahua',
    value: 'America/Chihuahua'
  },
  {
    label: '(UTC-07:00) Mazatlan',
    value: 'America/Mazatlan'
  },
  {
    label: '(UTC-06:00) Mexico City',
    value: 'America/Mexico_City'
  },
  {
    label: '(UTC-06:00) Monterrey',
    value: 'America/Monterrey'
  },
  {
    label: '(UTC-06:00) Saskatchewan',
    value: 'Canada/Saskatchewan'
  },
  {
    label: '(UTC-06:00) Central Time (US & Canada)',
    value: 'US/Central'
  },
  {
    label: '(UTC-05:00) Eastern Time (US & Canada)',
    value: 'US/Eastern'
  },
  {
    label: '(UTC-05:00) Indiana (East)',
    value: 'US/East-Indiana'
  },
  {
    label: '(UTC-05:00) Bogota',
    value: 'America/Bogota'
  },
  {
    label: '(UTC-05:00) Lima',
    value: 'America/Lima'
  },
  {
    label: '(UTC-04:30) Caracas',
    value: 'America/Caracas'
  },
  {
    label: '(UTC-04:00) Atlantic Time (Canada)',
    value: 'Canada/Atlantic'
  },
  {
    label: '(UTC-04:00) La Paz',
    value: 'America/La_Paz'
  },
  {
    label: '(UTC-04:00) Santiago',
    value: 'America/Santiago'
  },
  {
    label: '(UTC-03:30) Newfoundland',
    value: 'Canada/Newfoundland'
  },
  {
    label: '(UTC-03:00) Buenos Aires',
    value: 'America/Buenos_Aires'
  },
  {
    label: '(UTC-03:00) Greenland',
    value: 'Greenland'
  },
  {
    label: '(UTC-02:00) Stanley',
    value: 'Atlantic/Stanley'
  },
  {
    label: '(UTC-01:00) Azores',
    value: 'Atlantic/Azores'
  },
  {
    label: '(UTC-01:00) Cape Verde Is.',
    value: 'Atlantic/Cape_Verde'
  },
  {
    label: '(UTC) Casablanca',
    value: 'Africa/Casablanca'
  },
  {
    label: '(UTC) Dublin',
    value: 'Europe/Dublin'
  },
  {
    label: '(UTC) Lisbon',
    value: 'Europe/Lisbon'
  },
  {
    label: '(UTC) London',
    value: 'Europe/London'
  },
  {
    label: '(UTC) Monrovia',
    value: 'Africa/Monrovia'
  },
  {
    label: '(UTC+01:00) Amsterdam',
    value: 'Europe/Amsterdam'
  },
  {
    label: '(UTC+01:00) Belgrade',
    value: 'Europe/Belgrade'
  },
  {
    label: '(UTC+01:00) Berlin',
    value: 'Europe/Berlin'
  },
  {
    label: '(UTC+01:00) Bratislava',
    value: 'Europe/Bratislava'
  },
  {
    label: '(UTC+01:00) Brussels',
    value: 'Europe/Brussels'
  },
  {
    label: '(UTC+01:00) Budapest',
    value: 'Europe/Budapest'
  },
  {
    label: '(UTC+01:00) Copenhagen',
    value: 'Europe/Copenhagen'
  },
  {
    label: '(UTC+01:00) Ljubljana',
    value: 'Europe/Ljubljana'
  },
  {
    label: '(UTC+01:00) Madrid',
    value: 'Europe/Madrid'
  },
  {
    label: '(UTC+01:00) Paris',
    value: 'Europe/Paris'
  },
  {
    label: '(UTC+01:00) Prague',
    value: 'Europe/Prague'
  },
  {
    label: '(UTC+01:00) Rome',
    value: 'Europe/Rome'
  },
  {
    label: '(UTC+01:00) Sarajevo',
    value: 'Europe/Sarajevo'
  },
  {
    label: '(UTC+01:00) Skopje',
    value: 'Europe/Skopje'
  },
  {
    label: '(UTC+01:00) Stockholm',
    value: 'Europe/Stockholm'
  },
  {
    label: '(UTC+01:00) Vienna',
    value: 'Europe/Vienna'
  },
  {
    label: '(UTC+01:00) Warsaw',
    value: 'Europe/Warsaw'
  },
  {
    label: '(UTC+01:00) Zagreb',
    value: 'Europe/Zagreb'
  },
  {
    label: '(UTC+02:00) Athens',
    value: 'Europe/Athens'
  },
  {
    label: '(UTC+02:00) Bucharest',
    value: 'Europe/Bucharest'
  },
  {
    label: '(UTC+02:00) Cairo',
    value: 'Africa/Cairo'
  },
  {
    label: '(UTC+02:00) Harare',
    value: 'Africa/Harare'
  },
  {
    label: '(UTC+02:00) Helsinki',
    value: 'Europe/Helsinki'
  },
  {
    label: '(UTC+02:00) Istanbul',
    value: 'Europe/Istanbul'
  },
  {
    label: '(UTC+02:00) Jerusalem',
    value: 'Asia/Jerusalem'
  },
  {
    label: '(UTC+02:00) Kyiv',
    value: 'Europe/Kiev'
  },
  {
    label: '(UTC+02:00) Minsk',
    value: 'Europe/Minsk'
  },
  {
    label: '(UTC+02:00) Riga',
    value: 'Europe/Riga'
  },
  {
    label: '(UTC+02:00) Sofia',
    value: 'Europe/Sofia'
  },
  {
    label: '(UTC+02:00) Tallinn',
    value: 'Europe/Tallinn'
  },
  {
    label: '(UTC+02:00) Vilnius',
    value: 'Europe/Vilnius'
  },
  {
    label: '(UTC+03:00) Baghdad',
    value: 'Asia/Baghdad'
  },
  {
    label: '(UTC+03:00) Kuwait',
    value: 'Asia/Kuwait'
  },
  {
    label: '(UTC+03:00) Nairobi',
    value: 'Africa/Nairobi'
  },
  {
    label: '(UTC+03:00) Riyadh',
    value: 'Asia/Riyadh'
  },
  {
    label: '(UTC+03:00) Moscow',
    value: 'Europe/Moscow'
  },
  {
    label: '(UTC+03:30) Tehran',
    value: 'Asia/Tehran'
  },
  {
    label: '(UTC+04:00) Baku',
    value: 'Asia/Baku'
  },
  {
    label: '(UTC+04:00) Volgograd',
    value: 'Europe/Volgograd'
  },
  {
    label: '(UTC+04:00) Muscat',
    value: 'Asia/Muscat'
  },
  {
    label: '(UTC+04:00) Tbilisi',
    value: 'Asia/Tbilisi'
  },
  {
    label: '(UTC+04:00) Yerevan',
    value: 'Asia/Yerevan'
  },
  {
    label: '(UTC+04:30) Kabul',
    value: 'Asia/Kabul'
  },
  {
    label: '(UTC+05:00) Karachi',
    value: 'Asia/Karachi'
  },
  {
    label: '(UTC+05:00) Tashkent',
    value: 'Asia/Tashkent'
  },
  {
    label: '(UTC+05:30) Kolkata',
    value: 'Asia/Kolkata'
  },
  {
    label: '(UTC+05:45) Kathmandu',
    value: 'Asia/Kathmandu'
  },
  {
    label: '(UTC+06:00) Ekaterinburg',
    value: 'Asia/Yekaterinburg'
  },
  {
    label: '(UTC+06:00) Almaty',
    value: 'Asia/Almaty'
  },
  {
    label: '(UTC+06:00) Dhaka',
    value: 'Asia/Dhaka'
  },
  {
    label: '(UTC+07:00) Novosibirsk',
    value: 'Asia/Novosibirsk'
  },
  {
    label: '(UTC+07:00) Bangkok',
    value: 'Asia/Bangkok'
  },
  {
    label: '(UTC+07:00) Jakarta',
    value: 'Asia/Jakarta'
  },
  {
    label: '(UTC+08:00) Krasnoyarsk',
    value: 'Asia/Krasnoyarsk'
  },
  {
    label: '(UTC+08:00) Chongqing',
    value: 'Asia/Chongqing'
  },
  {
    label: '(UTC+08:00) Hong Kong',
    value: 'Asia/Hong_Kong'
  },
  {
    label: '(UTC+08:00) Kuala Lumpur',
    value: 'Asia/Kuala_Lumpur'
  },
  {
    label: '(UTC+08:00) Perth',
    value: 'Australia/Perth'
  },
  {
    label: '(UTC+08:00) Singapore',
    value: 'Asia/Singapore'
  },
  {
    label: '(UTC+08:00) Taipei',
    value: 'Asia/Taipei'
  },
  {
    label: '(UTC+08:00) Ulaan Bataar',
    value: 'Asia/Ulaanbaatar'
  },
  {
    label: '(UTC+08:00) Urumqi',
    value: 'Asia/Urumqi'
  },
  {
    label: '(UTC+09:00) Irkutsk',
    value: 'Asia/Irkutsk'
  },
  {
    label: '(UTC+09:00) Seoul',
    value: 'Asia/Seoul'
  },
  {
    label: '(UTC+09:00) Tokyo',
    value: 'Asia/Tokyo'
  },
  {
    label: '(UTC+09:30) Adelaide',
    value: 'Australia/Adelaide'
  },
  {
    label: '(UTC+09:30) Darwin',
    value: 'Australia/Darwin'
  },
  {
    label: '(UTC+10:00) Yakutsk',
    value: 'Asia/Yakutsk'
  },
  {
    label: '(UTC+10:00) Brisbane',
    value: 'Australia/Brisbane'
  },
  {
    label: '(UTC+10:00) Canberra',
    value: 'Australia/Canberra'
  },
  {
    label: '(UTC+10:00) Guam',
    value: 'Pacific/Guam'
  },
  {
    label: '(UTC+10:00) Hobart',
    value: 'Australia/Hobart'
  },
  {
    label: '(UTC+10:00) Melbourne',
    value: 'Australia/Melbourne'
  },
  {
    label: '(UTC+10:00) Port Moresby',
    value: 'Pacific/Port_Moresby'
  },
  {
    label: '(UTC+10:00) Sydney',
    value: 'Australia/Sydney'
  },
  {
    label: '(UTC+11:00) Vladivostok',
    value: 'Asia/Vladivostok'
  },
  {
    label: '(UTC+12:00) Magadan',
    value: 'Asia/Magadan'
  },
  {
    label: '(UTC+12:00) Auckland',
    value: 'Pacific/Auckland'
  },
  {
    label: '(UTC+12:00) Fiji',
    value: 'Pacific/Fiji'
  }
]

export const timeZoneOptions = [
  { value: -12, label: 'UTC -12:00, Baker Island Time' },
  { value: -11, label: 'UTC -11:00, Niue Time, Samoa Standard Time' },
  { value: -10, label: 'UTC -10:00, Hawaii-Aleutian Time,Cook Island Time' },
  { value: -9, label: 'UTC -09:00, Alaska Standard Time, Gambier Island Time' },
  { value: -8, label: 'UTC -08:00, Pacific Standard Time' },
  { value: -7, label: 'UTC -07:00, Mountain Standard Time' },
  { value: -6, label: 'UTC -06:00, Central Standard Time' },
  { value: -5, label: 'UTC -05:00, Eastern Standard Time' },
  { value: -4, label: 'UTC -04:00, Atlantic Standard Time' },
  {
    value: -3,
    label: 'UTC -03:00, Amazon Standard Time, Central Greenland Time'
  },
  {
    value: -2,
    label:
      'UTC -02:00, Fernando de Noronha Time, South Georgia &amp; the South Sandwich Islands Time'
  },
  {
    value: -1,
    label:
      'UTC -01:00, Azores Standard Time, Cape Verde Time, Eastern Greenland Time'
  },
  { value: 0, label: 'UTC 00:00, Western European Time, Greenwich Mean Time' },
  { value: 1, label: 'UTC +01:00, Central European Time, West African Time' },
  {
    value: 2,
    label: 'UTC +02:00, Eastern European Time, Central African Time'
  },
  { value: 3, label: 'UTC +03:00, Moscow Standard Time, Eastern African Time' },
  { value: 4, label: 'UTC +04:00, Gulf Standard Time, Samara Standard Time' },
  {
    value: 5,
    label: 'UTC +05:00, Pakistan Standard Time, Yekaterinburg Standard Time'
  },
  {
    value: 6,
    label: 'UTC +06:00, Bangladesh Time, Bhutan Time, Novosibirsk Standard Time'
  },
  { value: 7, label: 'UTC +07:00, Indochina Time, Krasnoyarsk Standard Time' },
  {
    value: 8,
    label:
      'UTC +08:00, Chinese Standard Time, Australian Western Standard Time, Irkutsk Standard Time'
  },
  {
    value: 9,
    label:
      'UTC +09:00, Japan Standard Time, Korea Standard Time, Chita Standard Time'
  },
  {
    value: 10,
    label:
      'UTC +10:00, Australian Eastern Standard Time, Vladivostok Standard Time'
  },
  {
    value: 11,
    label: 'UTC +11:00, Solomon Island Time, Magadan Standard Time'
  },
  {
    value: 12,
    label: 'UTC +12:00, New Zealand Time, Fiji Time, Kamchatka Standard Time'
  }
]

export const timeZoneMap: any = {
  '-12': 'Pacific/Fiji',
  '-11': 'Pacific/Midway',
  '-10': 'Pacific/Honolulu',
  '-9': 'Pacific/Gambier',
  '-8': 'Pacific/Pitcairn',
  '-7': 'US/Arizona',
  '-6': 'America/Mexico_City',
  '-5': 'America/Cancun',
  '-4': 'America/Campo_Grande',
  '-3.5': 'Canada/Newfoundland',
  '-3': 'Atlantic/Stanley',
  '-2': 'Atlantic/South_Georgia',
  '-1': 'Atlantic/Cape_Verde',
  0: 'UTC',
  1: 'Africa/Algiers',
  2: 'Africa/Blantyre',
  3: 'Europe/Moscow',
  4: 'Asia/Muscat',
  4.5: 'Asia/Kabul',
  5: 'Asia/Karachi',
  5.5: 'Asia/Kolkata',
  6: 'Asia/Dhaka',
  7: 'Asia/Ho_Chi_Minh',
  8: 'Asia/Hong_Kong',
  9: 'Asia/Tokyo',
  9.5: 'Australia/Darwin',
  10: 'Australia/Brisbane',
  11: 'Asia/Sakhalin',
  12: 'Pacific/Fiji',
  13: 'Pacific/Apia',
  14: 'Pacific/Kiritimati'
}

export default timezoneList
